import React, { useState, useEffect } from "react";
import * as S from "./Nav.styles";
// import PropTypes from "prop-types";
// import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { fas } from "@fortawesome/free-solid-svg-icons";
// import { library } from "@fortawesome/fontawesome-svg-core";

// library.add(fas);

const Nav = ({
  activeLogin,
  setActiveLogin,
  selectedMenuMob,
  setSelectedMenuMob,
}) => {
  const [active, setActive] = useState(false);
  const [navLogo, setNavLogo] = useState();

  const getBlockPics = async () => {
    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/v1/home/tstarlogo`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await res.json();
    // if (data.err) {
    //   return setError(data.err);
    // }

    setNavLogo(data);
  };
  useEffect(() => {
    getBlockPics();
  }, []);

  const toggleClass = () => {
    setActive(!active);
  };

  const navigate = useNavigate();

  return (
    <S.Nav
      className="navbar is-transparent has-background-grey-dark is-fixed-top is-spaced"
      role="navigation"
      aria-label="main navigation"
    >
      <div className="navbar-wrapper">
        <div className="navbar-content pl-2 pr-2">
          <div className="navbar-item ">
            <figure className="image is-48x48 has-background-white is-flex is-justify-content-center is-aling-items-center">
              <img
                src={navLogo && navLogo[0] && navLogo[0].filePath}
                alt={navLogo && navLogo[0] && navLogo[0].fileName}
                onClick={() => {
                  navigate("/");
                }}
              />
            </figure>
          </div>
          <div className="navbar-menu notburger-menu">
            <div className="navbar-start"></div>
            <div className="navbar-end">
              {localStorage.getItem("tokenCamp") ? (
                <button
                  className="button is-link"
                  onClick={() => {
                    localStorage.removeItem("tokenCamp");
                    navigate("/");
                    toggleClass();
                  }}
                >
                  Logout
                </button>
              ) : (
                <div className="buttons">
                  <button
                    className="button is-link"
                    onClick={() => {
                      navigate("/register");
                      toggleClass();
                    }}
                  >
                    Register
                  </button>
                </div>
              )}
            </div>
          </div>
          <div
            role="button"
            aria-label="menu"
            aria-expanded="false"
            className={`navbar-burger ${
              active ? "is-active" : ""
            } js-burger has-background-white`}
            onClick={() => {
              toggleClass();
            }}
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div className="burger-menu">
          <div className={`navbar-menu ${active ? "is-active" : ""}`}>
            <div className="navbar-start">
              <div className="navbar-dropdown is-boxed">
                {localStorage.getItem("tokenCamp") ? (
                  <div>
                    <div
                      key="1"
                      id="1"
                      className="navbar-item has-background-grey-lighter is-flex is-justify-content-center"
                      onClick={(e) => {
                        setSelectedMenuMob({
                          id: Number(e.currentTarget.id),
                        });
                        toggleClass();
                      }}
                    >
                      <p className="subtitle is-5">
                        <b>Main</b>
                      </p>
                    </div>
                    <div
                      key="2"
                      id="2"
                      className="navbar-item has-background-grey-lighter is-flex is-justify-content-center"
                      onClick={(e) => {
                        setSelectedMenuMob({
                          id: Number(e.currentTarget.id),
                        });
                        toggleClass();
                      }}
                    >
                      <p className="subtitle is-5">
                        <b>Account</b>
                      </p>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="navbar-end">
              <div className="navbar-item">
                <div className="buttons is-centered">
                  {localStorage.getItem("tokenCamp") ? (
                    <button
                      className="button is-link"
                      onClick={() => {
                        localStorage.removeItem("tokenCamp");
                        navigate("/");
                        toggleClass();
                        setSelectedMenuMob({ id: 1 });
                      }}
                    >
                      Logout
                    </button>
                  ) : (
                    <button
                      className="button is-link"
                      onClick={() => {
                        localStorage.removeItem("tokenCamp");
                        navigate("/register");
                        toggleClass();
                      }}
                    >
                      Register
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </S.Nav>
  );
};

export default Nav;
